import { render, staticRenderFns } from "./Company.vue?vue&type=template&id=61cf4bf0&scoped=true"
import script from "./Company.vue?vue&type=script&lang=js"
export * from "./Company.vue?vue&type=script&lang=js"
import style0 from "./Company.vue?vue&type=style&index=0&id=61cf4bf0&prod&scoped=true&lang=css"
import style1 from "./Company.vue?vue&type=style&index=1&id=61cf4bf0&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61cf4bf0",
  null
  
)

export default component.exports